<template>
  <div id="app">
    <router-view
      :key="$route.matched[0] ? $route.matched[0].name : null"
    ></router-view>
  </div>
</template>

<script>
import SetCustomCookie from "@foxit/sso_cookie";
new SetCustomCookie({
  webProductName: "printer_Web",
});
export default {
  name: "App",
};
</script>

<style lang="scss">
$theme-color: #1a4bff;
#app {
  height: 100%;
}
@import "/src/assets/scss/reset.scss";
@import "/src/assets/scss/resetVant.scss";
</style>
